import './Contact.scss';

const Contact = () => (
  <section className="contact" id="contact">
    <span className="contact__label">04</span>
    <div className="contact__inner">
      <h2 className="contact__title">
        CRÉONS<br />
        QUELQUE CHOSE<br />
        DE GRAND.
      </h2>
      <div className="contact__right">
        <a href="mailto:bazire.fabien@gmail.com" className="contact__cta">
          PRENDRE CONTACT →
        </a>
      </div>
    </div>
  </section>
);

export default Contact;
